import { getWindow } from 'ts/window/Window';
import * as ConfigService from '../../../../config/ConfigService';

import { BROWSER_BACK, FLOW_PARAM, REDIRECT_URL_PARAM } from 'ts/constants/UrlParams';
import { ErrorFlow } from './ErrorFlow';
import { ERROR_CODES } from './ErrorCodes';
import { getRegisterBootstrapUrl } from '../../../../config/ConfigService';

/**
 * @param errorCode
 * @param flow - the flow the user is coming from
 * @param redirectUrl - if the back button should go to a specific page (will default to /login if no redirectUrl provided)
 * @param history - the history object if it is a react component (will use window.location if history not passed)
 * @param useBrowserBack - whether to use browser back or not
 */
const navigateToErrorPage = (
  errorCode: string,
  flow: ErrorFlow,
  redirectUrl?: string,
  history?: any,
  useBrowserBack?: boolean,
) => {
  const queryString = generateQueryString(flow, redirectUrl, useBrowserBack);
  if (history) {
    history.push(`/error/${errorCode}?${queryString}`);
  } else {
    getWindow().location.assign(`${ConfigService.getErrorPageUrl()}/${errorCode}?${queryString}`);
  }
};

const generateQueryString = (flow: ErrorFlow, redirectUrl?: string, useBrowserBack?: boolean) => {
  const params = new URLSearchParams({
    [FLOW_PARAM]: flow,
  });
  if (redirectUrl) {
    params.append(REDIRECT_URL_PARAM, redirectUrl);
  }
  if (useBrowserBack) {
    params.append(BROWSER_BACK, 'true');
  }
  return params.toString();
};

const navigateToErrorPageFromRegister = (history: any) => () => {
  navigateToErrorPage(
    'registration_error',
    ErrorFlow.register,
    ConfigService.getRegisterBootstrapUrl(),
    history,
  );
};

const navigateToErrorPageFromRegistrationSetPassword = () => {
  navigateToErrorPage(
    ERROR_CODES.SET_PW_ERROR,
    ErrorFlow.registerResetPassword,
    getRegisterBootstrapUrl(),
  );
};

const navigateToErrorPageFromManualRegSetPassword = () => {
  navigateToErrorPage(ERROR_CODES.SET_PW_ERROR, ErrorFlow.manualReg, getRegisterBootstrapUrl());
};

const navigateToErrorPageFromForgotPassword = (history: any) => () => {
  navigateToErrorPage(
    'forgotpassword_error',
    ErrorFlow.resetPassword,
    ConfigService.getResetPasswordBootstrapUrl(),
    history,
  );
};

const navigateToErrorPageFromLogin = (errorCode: string, history?) => {
  navigateToErrorPage(errorCode, ErrorFlow.login, ConfigService.getLoginBootstrapUrl(), history);
};

const navigateToErrorPageFromIframeLogin = (errorCode: string, history?) => {
  const queryString = generateQueryString(
    ErrorFlow.login,
    ConfigService.getIFrameLoginBootstrapUrl(),
  );
  history.push(`/iframe-login/error/${errorCode}?${queryString}`);
};

const navigateToErrorPageFromForgotEmail = (errorCode: string, history) => {
  navigateToErrorPage(errorCode, ErrorFlow.forgotEmail, '', history, true);
};

export {
  navigateToErrorPage,
  navigateToErrorPageFromLogin,
  navigateToErrorPageFromRegister,
  navigateToErrorPageFromForgotPassword,
  navigateToErrorPageFromForgotEmail,
  navigateToErrorPageFromIframeLogin,
  navigateToErrorPageFromManualRegSetPassword,
  navigateToErrorPageFromRegistrationSetPassword,
};
